/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

import { BlendBridge } from 'blb-types/blendBridge';
import { baseRequest } from './baseRequest';
import { handleAxiosRequest } from './requestHelper';
const baseRoute = '/api/internal/users';
const service = BlendBridge.UserPreferenceServiceTypes.ECLOSE;
export const getUserProfile = principalId => baseRequest.get(`${baseRoute}/${principalId}`);
export const updateUserProfile = (principalId, body) => baseRequest.patch(`${baseRoute}/${principalId}`, body);
export const getUserPreference = principalId => baseRequest.get(`${baseRoute}/${principalId}/preference`, {
  params: {
    service
  }
});
export const updateUserPreference = (principalId, body) => baseRequest.patch(`${baseRoute}/${principalId}/preference`, body);
export const updateUserAddress = (principalId, body) => baseRequest.put(`${baseRoute}/${principalId}/address`, body);
export const searchForParty = body => {
  return baseRequest.post(`${baseRoute}/search`, body);
};
export const getCredentialUploadTasksForUser = principalId => baseRequest.get(`${baseRoute}/${principalId}/credentials`);
export const getAssignmentCandidates = function (principalId) {
  let isOpsDeskAssignmentFilters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return baseRequest.get(`${baseRoute}/assignment-candidates`, {
    params: {
      currentPrincipalId: principalId,
      isOpsDeskAssignmentFilters
    }
  });
};
export const getUserGroups = principalId => baseRequest.get(`${baseRoute}/${principalId}/groups`);
export const getOutstandingInvitations = principalId => handleAxiosRequest(baseRequest.get(`${baseRoute}/${principalId}/outstanding-invitations`));
export const getUserFeatures = () => baseRequest.get(`${baseRoute}/user-features-configurations`);